export default __webpack_public_path__ + "static/media/0.c3f33e7e.jpg";